const OS_HIGH_RISK_DATA = [
  {
    t: 0.0,
    s: 1.0,
    lower: 1.0,
    upper: 1.0,
  },
  {
    t: 0.6,
    s: 0.9945652174,
    lower: 0.9620515658,
    upper: 0.9992326461,
  },
  {
    t: 1.3,
    s: 0.9891304348,
    lower: 0.9572415519,
    upper: 0.9972704161,
  },
  {
    t: 1.5,
    s: 0.9782608696,
    lower: 0.9431198257,
    upper: 0.9917850155,
  },
  {
    t: 1.6,
    s: 0.972826087,
    lower: 0.935951675,
    upper: 0.9885987542,
  },
  {
    t: 1.7,
    s: 0.9619565217,
    lower: 0.9218603034,
    upper: 0.9816801315,
  },
  {
    t: 1.8,
    s: 0.9565217391,
    lower: 0.9149450793,
    upper: 0.9780162892,
  },
  {
    t: 2.1,
    s: 0.9510869565,
    lower: 0.9081096501,
    upper: 0.9742455654,
  },
  {
    t: 2.2,
    s: 0.9456521739,
    lower: 0.9013471175,
    upper: 0.9703831172,
  },
  {
    t: 2.3,
    s: 0.9402173913,
    lower: 0.8946509644,
    upper: 0.9664406849,
  },
  {
    t: 2.4,
    s: 0.9347826087,
    lower: 0.8880153366,
    upper: 0.9624275868,
  },
  {
    t: 2.5,
    s: 0.9293478261,
    lower: 0.881435076,
    upper: 0.9583513697,
  },
  {
    t: 2.6,
    s: 0.9130434783,
    lower: 0.8619840891,
    upper: 0.9458012781,
  },
  {
    t: 2.7,
    s: 0.8967391304,
    lower: 0.8428987563,
    upper: 0.9328560603,
  },
  {
    t: 2.8,
    s: 0.8913043478,
    lower: 0.8366062663,
    upper: 0.9284675424,
  },
  {
    t: 3.2,
    s: 0.8804347826,
    lower: 0.8241134055,
    upper: 0.9195939638,
  },
  {
    t: 3.4,
    s: 0.875,
    lower: 0.8179097799,
    upper: 0.915112578,
  },
  {
    t: 3.5,
    s: 0.8641304348,
    lower: 0.8055811337,
    upper: 0.9060684161,
  },
  {
    t: 3.6,
    s: 0.8532608696,
    lower: 0.7933493827,
    upper: 0.8969244348,
  },
  {
    t: 3.8,
    s: 0.847826087,
    lower: 0.7872672509,
    upper: 0.8923178369,
  },
  {
    t: 3.9,
    s: 0.8423913043,
    lower: 0.7812064012,
    upper: 0.8876894799,
  },
  {
    t: 4.0,
    s: 0.8369565217,
    lower: 0.7751660132,
    upper: 0.8830402462,
  },
  {
    t: 4.1,
    s: 0.8205456095,
    lower: 0.7570174764,
    upper: 0.8688975081,
  },
  {
    t: 4.3,
    s: 0.8150753055,
    lower: 0.7510055756,
    upper: 0.8641457216,
  },
  {
    t: 4.4,
    s: 0.8041346974,
    lower: 0.7390345026,
    upper: 0.8545895833,
  },
  {
    t: 4.5,
    s: 0.7931940892,
    lower: 0.7271301881,
    upper: 0.8449669564,
  },
  {
    t: 4.6,
    s: 0.7877237852,
    lower: 0.7212018662,
    upper: 0.8401319263,
  },
  {
    t: 4.7,
    s: 0.7822534811,
    lower: 0.7152888562,
    upper: 0.8352816715,
  },
  {
    t: 4.9,
    s: 0.776783177,
    lower: 0.7093907584,
    upper: 0.8304165974,
  },
  {
    t: 5.0,
    s: 0.7658425689,
    lower: 0.6976378208,
    upper: 0.8206434909,
  },
  {
    t: 5.1,
    s: 0.7603722648,
    lower: 0.6917822965,
    upper: 0.8157361525,
  },
  {
    t: 5.2,
    s: 0.7549019608,
    lower: 0.6859403122,
    upper: 0.8108153866,
  },
  {
    t: 5.4,
    s: 0.7439613527,
    lower: 0.6742958017,
    upper: 0.8009347506,
  },
  {
    t: 5.7,
    s: 0.7330207445,
    lower: 0.6627021255,
    upper: 0.7910037786,
  },
  {
    t: 5.9,
    s: 0.7220801364,
    lower: 0.6511573519,
    upper: 0.781024432,
  },
  {
    t: 6.0,
    s: 0.7056692242,
    lower: 0.6339281511,
    upper: 0.7659685031,
  },
  {
    t: 6.1,
    s: 0.7001989201,
    lower: 0.628207775,
    upper: 0.7609274628,
  },
  {
    t: 6.4,
    s: 0.683788008,
    lower: 0.6111123457,
    upper: 0.745739568,
  },
  {
    t: 6.5,
    s: 0.6728473998,
    lower: 0.5997686378,
    upper: 0.7355618616,
  },
  {
    t: 6.6,
    s: 0.6673770958,
    lower: 0.5941123463,
    upper: 0.7304576958,
  },
  {
    t: 7.0,
    s: 0.6619067917,
    lower: 0.5884662634,
    upper: 0.7253434919,
  },
  {
    t: 7.4,
    s: 0.6509661836,
    lower: 0.5772042633,
    upper: 0.7150854426,
  },
  {
    t: 7.7,
    s: 0.6454958795,
    lower: 0.5715881309,
    upper: 0.7099418183,
  },
  {
    t: 7.8,
    s: 0.6399788207,
    lower: 0.5659259296,
    upper: 0.7047506145,
  },
  {
    t: 7.9,
    s: 0.6289447031,
    lower: 0.5546316958,
    upper: 0.6943389928,
  },
  {
    t: 8.0,
    s: 0.6233788208,
    lower: 0.5489414368,
    upper: 0.6890789418,
  },
  {
    t: 8.1,
    s: 0.61214677,
    lower: 0.5374727404,
    upper: 0.6784475425,
  },
  {
    t: 8.2,
    s: 0.5952986937,
    lower: 0.5203480561,
    upper: 0.6624263263,
  },
  {
    t: 8.3,
    s: 0.5840666429,
    lower: 0.5089828379,
    upper: 0.6516969856,
  },
  {
    t: 8.4,
    s: 0.5784506175,
    lower: 0.5033153751,
    upper: 0.6463179551,
  },
  {
    t: 8.5,
    s: 0.5616025412,
    lower: 0.4863728078,
    upper: 0.6301241015,
  },
  {
    t: 8.7,
    s: 0.5503704904,
    lower: 0.4751270714,
    upper: 0.6192813814,
  },
  {
    t: 9.0,
    s: 0.5279063888,
    lower: 0.4527523843,
    upper: 0.597484973,
  },
  {
    t: 9.1,
    s: 0.5166743379,
    lower: 0.4416229273,
    upper: 0.5865317424,
  },
  {
    t: 9.2,
    s: 0.5110583125,
    lower: 0.4360725913,
    upper: 0.5810414426,
  },
  {
    t: 9.3,
    s: 0.5054422871,
    lower: 0.4305318307,
    upper: 0.575542038,
  },
  {
    t: 9.6,
    s: 0.4942102363,
    lower: 0.4194789992,
    upper: 0.5645159484,
  },
  {
    t: 9.7,
    s: 0.4829781855,
    lower: 0.4084643986,
    upper: 0.5534535078,
  },
  {
    t: 10.0,
    s: 0.4773621601,
    lower: 0.4029714408,
    upper: 0.5479086517,
  },
  {
    t: 10.2,
    s: 0.4717461346,
    lower: 0.3974880553,
    upper: 0.5423546959,
  },
  {
    t: 10.3,
    s: 0.4661301092,
    lower: 0.3920142548,
    upper: 0.5367916294,
  },
  {
    t: 10.6,
    s: 0.4605140838,
    lower: 0.3865500561,
    upper: 0.5312194376,
  },
  {
    t: 10.7,
    s: 0.4548980584,
    lower: 0.3810954794,
    upper: 0.5256381027,
  },
  {
    t: 10.8,
    s: 0.449282033,
    lower: 0.3756505491,
    upper: 0.5200476029,
  },
  {
    t: 11.0,
    s: 0.4436660076,
    lower: 0.3702152934,
    upper: 0.5144479134,
  },
  {
    t: 11.1,
    s: 0.4380499822,
    lower: 0.3647897446,
    upper: 0.5088390053,
  },
  {
    t: 11.2,
    s: 0.4324339568,
    lower: 0.3593739389,
    upper: 0.5032208464,
  },
  {
    t: 11.6,
    s: 0.4212019059,
    lower: 0.3485717225,
    upper: 0.4919566277,
  },
  {
    t: 11.7,
    s: 0.4155858805,
    lower: 0.3431854051,
    upper: 0.4863104843,
  },
  {
    t: 11.8,
    s: 0.4155858805,
    lower: 0.3431854051,
    upper: 0.4863104843,
  },
  {
    t: 11.9,
    s: 0.4098929233,
    lower: 0.3377238546,
    upper: 0.4805885099,
  },
  {
    t: 12.0,
    s: 0.3928140515,
    lower: 0.3214030972,
    upper: 0.4633627213,
  },
  {
    t: 12.1,
    s: 0.3871210942,
    lower: 0.3159843594,
    upper: 0.457600632,
  },
  {
    t: 12.2,
    s: 0.3814281369,
    lower: 0.3105765009,
    upper: 0.4518283483,
  },
  {
    t: 12.4,
    s: 0.3757351797,
    lower: 0.3051796032,
    upper: 0.446045794,
  },
  {
    t: 12.5,
    s: 0.3700422224,
    lower: 0.2997937539,
    upper: 0.4402528877,
  },
  {
    t: 12.6,
    s: 0.3700422224,
    lower: 0.2997937539,
    upper: 0.4402528877,
  },
  {
    t: 12.9,
    s: 0.3582948502,
    lower: 0.2886606004,
    upper: 0.4283216858,
  },
  {
    t: 13.1,
    s: 0.3465474781,
    lower: 0.2775794036,
    upper: 0.4163429107,
  },
  {
    t: 13.2,
    s: 0.340673792,
    lower: 0.2720585784,
    upper: 0.4103353992,
  },
  {
    t: 13.3,
    s: 0.334800106,
    lower: 0.2665511077,
    upper: 0.4043156382,
  },
  {
    t: 13.5,
    s: 0.334800106,
    lower: 0.2665511077,
    upper: 0.4043156382,
  },
  {
    t: 13.7,
    s: 0.3288215326,
    lower: 0.2609427315,
    upper: 0.3981928332,
  },
  {
    t: 13.9,
    s: 0.3228429593,
    lower: 0.255349082,
    upper: 0.3920566639,
  },
  {
    t: 14.0,
    s: 0.3108858127,
    lower: 0.2442066289,
    upper: 0.3797435836,
  },
  {
    t: 14.1,
    s: 0.3049072394,
    lower: 0.2386581894,
    upper: 0.3735663209,
  },
  {
    t: 14.2,
    s: 0.2929500927,
    lower: 0.2276078955,
    upper: 0.3611693832,
  },
  {
    t: 14.4,
    s: 0.2869715194,
    lower: 0.2221064888,
    upper: 0.3549492832,
  },
  {
    t: 15.0,
    s: 0.2809929461,
    lower: 0.2166212336,
    upper: 0.348714456,
  },
  {
    t: 15.3,
    s: 0.2690357994,
    lower: 0.205700253,
    upper: 0.3361996105,
  },
  {
    t: 15.8,
    s: 0.2570786528,
    lower: 0.1948472938,
    upper: 0.323622661,
  },
  {
    t: 15.9,
    s: 0.2511000795,
    lower: 0.1894471428,
    upper: 0.3173101348,
  },
  {
    t: 16.1,
    s: 0.2451215062,
    lower: 0.1840650274,
    upper: 0.310981127,
  },
  {
    t: 16.5,
    s: 0.2391429328,
    lower: 0.1787013416,
    upper: 0.3046352741,
  },
  {
    t: 17.0,
    s: 0.2391429328,
    lower: 0.1787013416,
    upper: 0.3046352741,
  },
  {
    t: 17.1,
    s: 0.2330110628,
    lower: 0.1731946906,
    upper: 0.2981385296,
  },
  {
    t: 17.3,
    s: 0.2268791927,
    lower: 0.1677095255,
    upper: 0.2916224018,
  },
  {
    t: 17.5,
    s: 0.2205769929,
    lower: 0.1620662642,
    upper: 0.2849393356,
  },
  {
    t: 17.6,
    s: 0.2142747931,
    lower: 0.1564483185,
    upper: 0.2782336989,
  },
  {
    t: 17.8,
    s: 0.2079725933,
    lower: 0.1508563367,
    upper: 0.2715048887,
  },
  {
    t: 17.9,
    s: 0.2016703935,
    lower: 0.145291023,
    upper: 0.2647522531,
  },
  {
    t: 18.6,
    s: 0.2016703935,
    lower: 0.145291023,
    upper: 0.2647522531,
  },
  {
    t: 18.8,
    s: 0.1951648969,
    lower: 0.139539379,
    upper: 0.2578013038,
  },
  {
    t: 18.9,
    s: 0.1886594004,
    lower: 0.1338200038,
    upper: 0.2508218553,
  },
  {
    t: 19.4,
    s: 0.1886594004,
    lower: 0.1338200038,
    upper: 0.2508218553,
  },
  {
    t: 20.4,
    s: 0.1819215646,
    lower: 0.127889213,
    upper: 0.2436173498,
  },
  {
    t: 20.7,
    s: 0.1751837289,
    lower: 0.1219981544,
    upper: 0.236378114,
  },
  {
    t: 20.8,
    s: 0.1684458932,
    lower: 0.1161481579,
    upper: 0.2291029239,
  },
  {
    t: 21.3,
    s: 0.1617080575,
    lower: 0.110340702,
    upper: 0.2217904254,
  },
  {
    t: 21.6,
    s: 0.1549702217,
    lower: 0.1045774341,
    upper: 0.2144391169,
  },
  {
    t: 22.2,
    s: 0.1414945503,
    lower: 0.0931910401,
    upper: 0.1996132004,
  },
  {
    t: 22.5,
    s: 0.1347567146,
    lower: 0.0875722889,
    upper: 0.1921346466,
  },
  {
    t: 22.7,
    s: 0.1347567146,
    lower: 0.0875722889,
    upper: 0.1921346466,
  },
  {
    t: 22.9,
    s: 0.1347567146,
    lower: 0.0875722889,
    upper: 0.1921346466,
  },
  {
    t: 23.1,
    s: 0.1272702304,
    lower: 0.0812382638,
    upper: 0.1840040815,
  },
  {
    t: 23.5,
    s: 0.1197837463,
    lower: 0.0749903738,
    upper: 0.175799697,
  },
  {
    t: 24.6,
    s: 0.1197837463,
    lower: 0.0749903738,
    upper: 0.175799697,
  },
  {
    t: 24.8,
    s: 0.1117981632,
    lower: 0.0683183769,
    upper: 0.1671380353,
  },
  {
    t: 25.4,
    s: 0.1038125801,
    lower: 0.0617715806,
    upper: 0.1583701354,
  },
  {
    t: 25.7,
    s: 0.095826997,
    lower: 0.0553580932,
    upper: 0.1494889319,
  },
  {
    t: 25.8,
    s: 0.0878414139,
    lower: 0.0490878541,
    upper: 0.1404858347,
  },
  {
    t: 26.2,
    s: 0.0878414139,
    lower: 0.0490878541,
    upper: 0.1404858347,
  },
  {
    t: 27.5,
    s: 0.0790572725,
    lower: 0.0421880111,
    upper: 0.1307923611,
  },
  {
    t: 28.2,
    s: 0.0790572725,
    lower: 0.0421880111,
    upper: 0.1307923611,
  },
  {
    t: 31.1,
    s: 0.0691751135,
    lower: 0.0344568023,
    upper: 0.1202246922,
  },
  {
    t: 32.2,
    s: 0.0691751135,
    lower: 0.0344568023,
    upper: 0.1202246922,
  },
  {
    t: 33.1,
    s: 0.0691751135,
    lower: 0.0344568023,
    upper: 0.1202246922,
  },
  {
    t: 34.3,
    s: 0.0553400908,
    lower: 0.0232456678,
    upper: 0.1078640313,
  },
  {
    t: 38.0,
    s: 0.0415050681,
    lower: 0.0137853718,
    upper: 0.0941088148,
  },
  {
    t: 38.9,
    s: 0.0276700454,
    lower: 0.0062966399,
    upper: 0.0789066213,
  },
  {
    t: 45.7,
    s: 0.0138350227,
    lower: 0.0013482852,
    upper: 0.0625065842,
  },
  {
    t: 53.0,
    s: 0.0138350227,
    lower: 0.0013482852,
    upper: 0.0625065842,
  },
];

export default OS_HIGH_RISK_DATA;
